import { cva } from 'class-variance-authority'

import { SurfaceElevation, SurfaceRadius, SurfaceVariant } from './types'

/*
 * Note: the `border` utility renders as 0.5px in this design system
 * (not Tailwind's 1px default). The width is set globally by
 * `--default-border-width: 0.5px` in `src/styles/radius/radius.css`.
 * Older components that wrote `border-[0.5px]` are restating that default.
 */
export const surfaceVariants = cva([], {
  defaultVariants: {
    variant: SurfaceVariant.Elevated,
    radius: SurfaceRadius.Medium,
    elevation: SurfaceElevation.Medium,
  },
  variants: {
    variant: {
      [SurfaceVariant.Elevated]:
        'bg-surface-primary border border-border-default',
      [SurfaceVariant.Outlined]:
        'bg-surface-primary border border-border-default',
      [SurfaceVariant.Flat]: 'bg-surface-foundation',
      [SurfaceVariant.Secondary]: 'bg-surface-secondary',
    },
    radius: {
      [SurfaceRadius.None]: 'rounded-none',
      [SurfaceRadius.ExtraSmall]: 'rounded-xs',
      [SurfaceRadius.Small]: 'rounded-sm',
      [SurfaceRadius.Medium]: 'rounded-md',
      [SurfaceRadius.Large]: 'rounded-lg',
    },
    // Shadow is applied via compoundVariants so it only takes effect
    // for variant=elevated. Outlined/flat ignore the elevation prop.
    elevation: {
      [SurfaceElevation.ExtraSmall]: '',
      [SurfaceElevation.Small]: '',
      [SurfaceElevation.Medium]: '',
      [SurfaceElevation.Large]: '',
    },
  },
  compoundVariants: [
    {
      variant: SurfaceVariant.Elevated,
      elevation: SurfaceElevation.ExtraSmall,
      class: 'shadow-xs',
    },
    {
      variant: SurfaceVariant.Elevated,
      elevation: SurfaceElevation.Small,
      class: 'shadow-sm',
    },
    {
      variant: SurfaceVariant.Elevated,
      elevation: SurfaceElevation.Medium,
      class: 'shadow-md',
    },
    {
      variant: SurfaceVariant.Elevated,
      elevation: SurfaceElevation.Large,
      class: 'shadow-lg',
    },
  ],
})
